import "core-js/modules/es.array.join";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.parse-int";
import "core-js/modules/es.regexp.to-string";
var VISITOR_ID_NUM_MIN = 100000000;
var VISITOR_ID_NUM_MAX = 999999999;
export var VISITOR_ID_COOKIE_NAME = 'cpVisitorId';
export var isValidVisitorId = function isValidVisitorId(str) {
  return /^\d{9}[a-f0-9]{13}$/.test(str);
};
export var visitorIdInsidePercentile = function visitorIdInsidePercentile(visitorId, min, max) {
  var idNumberRange = VISITOR_ID_NUM_MAX - VISITOR_ID_NUM_MIN;
  var lowerBound = VISITOR_ID_NUM_MIN + Math.round(idNumberRange * min);
  var upperBound = VISITOR_ID_NUM_MIN + Math.round(idNumberRange * max);
  var intPartOfVisitorId = parseInt((visitorId || '').substr(0, 9), 10);
  return intPartOfVisitorId >= lowerBound && intPartOfVisitorId <= upperBound;
};
export var generateVisitorId = function generateVisitorId() {
  var rand = function rand(min, max) {
    return Math.round(Math.random() * (max - min) + min);
  };

  return ["".concat(rand(VISITOR_ID_NUM_MIN, VISITOR_ID_NUM_MAX)), [rand(0x100000, 0xFFFFFF).toString('16'), rand(0x100000, 0xFFFFFF).toString('16'), rand(0x100000, 0xFFFFFF).toString('16')].join('').substr(0, 13)].join('');
};